


var dd_homeVideoZoneObject;

var dd_homeVideoZone = function(){
  this.yt_player;
  this.videoPlayerInitialized;
  this.yt_playerInterval;
  this.heightvdhm;
  
  this.currentVideoID = "";
  this.iWindowsSize;
  this.youtubeScriptCalled = false;
  this.done = false;
  
  this.vid;
  this.pauseButton;
}

dd_homeVideoZone.prototype.init = function(){
  var thisObject = this;
  this.videoPlayerInitialized = false;
  this.vid=document.getElementById("bgvidhome");
  this.pauseButton = document.querySelector("#play_one");
  
  this.iWindowsSize = jQuery(window).width();

  if (this.iWindowsSize  > 1024 ){
    this.heightvdhm = 480;
  }
  if (this.iWindowsSize  > 768 && this.iWindowsSize  <= 1024  ){
    this.heightvdhm = 390;
  }
  if (this.iWindowsSize  <= 768  ){
    this.heightvdhm = 390;
  }
  
  if (window.matchMedia('(prefers-reduced-motion)').matches) {
      this.vid.removeAttribute("autoplay");
      this.vid.pause();
  }
  
  this.vid.addEventListener('ended', function()
  {
  // only functional if "loop" is removed 
  this.vid.pause();
  // to capture IE10
  this.vidFade();
  });
  
  jQuery("#play_one").click (function(){
    //Google analytic - Play Underarms
    dd_googleAnalyticsObject.event("video","videoPlay","videoPlay_home_main");
    //thisObject.playHomeVideo("2XWjsI3AcTA");
    
    thisObject.playHomeVideo("0LoKP0-ub7I");
    

    jQuery('#video_use_underarms').fadeIn(300);
  });
  
  jQuery("#play_mvmt_underarms").click (function(){
    //Google analytic - Play Underarms
    dd_googleAnalyticsObject.event("video","videoPlay","videoPlay_home_mvmt_underarms");
    thisObject.currentVideoID = 'afjZNGi0fzI';
    thisObject.playHomeVideo("afjZNGi0fzI");

    jQuery('#video_use_underarms').fadeIn(300);
  });
  
  jQuery("#play_mvmt_hands").click (function(){
    //Google analytic - Play Underarms
    dd_googleAnalyticsObject.event("video","videoPlay","videoPlay_home_mvmt_hands");
    thisObject.currentVideoID = 'B9DDDd3fp1s';
    thisObject.playHomeVideo("B9DDDd3fp1s");

    jQuery('#video_use_underarms').fadeIn(300);
  });
  
  jQuery("#play_mvmt_feet").click (function(){
    //Google analytic - Play Underarms
    dd_googleAnalyticsObject.event("video","videoPlay","videoPlay_home_mvmt_feet");
    thisObject.currentVideoID = 'CWqHiTd6qJM';
    thisObject.playHomeVideo("CWqHiTd6qJM");

    jQuery('#video_use_underarms').fadeIn(300);
  });
  
  jQuery(".close_video_use_underarms").click (function(){
    
    //Google analytic - Play Underarms
    dd_googleAnalyticsObject.event("video","videoClose","videoClose_home_underarms");
    
    jQuery('#video_use_underarms').fadeOut(300);
    
    jQuery("#ppdd_vidwrp_ytVid_wrapper").html('<div id="ppdd_vidwrp_ytVid"></div>');

    thisObject.vid.classList.remove("stopfade");

    //Stop Youtube Embed Video
    //thisObject.yt_player.stopVideo();
    
  });
  
  
};

dd_homeVideoZone.prototype.playHomeVideo = function(videoID){
  var thisObject = this;
  
  //Reset
  jQuery("#ppdd_vidwrp_ytVid_wrapper").html('<div id="ppdd_vidwrp_ytVid"></div>');
  var videoContainer = jQuery("#ppdd_vidwrp_ytVid");
  
  videoContainer.html('<iframe id="ytplayer" type="text/html" width="100%" height="480" src="https://www.youtube.com/embed/'+videoID+'?autoplay=1" frameborder="0"></iframe>');
  
  
  
  /*if(!thisObject.videoPlayerInitialized){
    thisObject.yt_playerInterval = setInterval(function(){
      if(typeof YT !== "undefined"){
        thisObject.yt_player = new YT.Player('ppdd_vidwrp_ytVid', {
          height: thisObject.heightvdhm, //480
          width: '100%',
          videoId: videoID,
          events: {
            'onReady': function(event){jQuery('#video_use_underarms').fadeIn(300);thisObject.yt_player.seekTo(0);},
            'onStateChange': function(event){}
          }
        });
        thisObject.videoPlayerInitialized = true;
        clearInterval(thisObject.yt_playerInterval);
      }
    },500);  
  }else{
    thisObject.yt_player.loadVideoById(videoID);
    thisObject.yt_player.seekTo(0);
  }*/
  
};

dd_homeVideoZone.prototype.callYoutubeScript = function(){
  /*if(this.youtubeScriptCalled){return false;}
  var tag = document.createElement('script');

  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);*/
};

dd_homeVideoZone.prototype.onYouTubeIframeAPIReady = function(){
  var thisObject = this;
};

dd_homeVideoZone.prototype.onPlayerReady = function(event){
  /*this.vid.classList.add("stopfade");
  this.yt_player.playVideo();
  jQuery('#video_use_underarms').fadeIn(300);*/
};

dd_homeVideoZone.prototype.onPlayerStateChange = function(event){
  /*
    if (event.data == YT.PlayerState.PLAYING && !done) {
      setTimeout(yt_stopVideo, 6000);
      done = true;
    }
    */
};

dd_homeVideoZone.prototype.vidFade = function(){
  this.vid.classList.add("stopfade");
};

//Declare the dd_homeVideoZone
dd_homeVideoZoneObject = new dd_homeVideoZone();

jQuery(document).ready(function(){
    //Initiate the events (buttons ...)
    dd_homeVideoZoneObject.init();
});

function onYouTubeIframeAPIReady() {
	dd_homeVideoZoneObject.onYouTubeIframeAPIReady();
}
// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
  dd_homeVideoZoneObject.onPlayerReady(event);
}

// 5. The API calls this function when the player's state changes.
//    The function indicates that when playing a video (state=1),
//    the player should play for six seconds and then stop.
function onPlayerStateChange(event) {
  dd_homeVideoZoneObject.onPlayerStateChange(event);
}


  
  
  